import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'agentBadgeRibbonImagepath'
})
export class AgentBadgeRibbonImagepathPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    // return css class based on alert type
    let imageUrl: string;
    const baseImageUrl = '../assets/images/';
    switch (args) {
      case AgentBadgeRibbonEnum.AgentBadgeCertification:
        switch (value) {
          default: {
            imageUrl = 'badge-star-ribbon-100';
            return baseImageUrl + imageUrl + '.svg';
            break;
          }
        }
        break;
      case AgentBadgeRibbonEnum.AgentBadgeAward:
        switch (value) {
          default: {
            imageUrl = 'badge-star-ribbon-100';
            return baseImageUrl + imageUrl + '.svg';
            break;
          }
        }
        break;
      case AgentBadgeRibbonEnum.AgentBadgeLeadership:
        switch (value) {
          default: {
            imageUrl = 'badge-star-ribbon-100';
            return baseImageUrl + imageUrl + '.svg';
            break;
          }
        }
        break;
      case AgentBadgeRibbonEnum.AgentBadgeStateLeadership:
        switch (value) {
          default: {
            imageUrl = 'badge-star-stamp-100';
            return baseImageUrl + imageUrl + '.svg';
            break;
          }
        }
        break;
      case AgentBadgeRibbonEnum.AgentRibbonNationalPresident:
        switch (value) {
          default: {
            imageUrl = 'badge-star-stamp-100';
            return baseImageUrl + imageUrl + '.svg';
            break;
          }
        }
        break;
      case AgentBadgeRibbonEnum.AgentRibbonStateLeadership:
        switch (value) {
          default: {
            imageUrl = 'badge-star-stamp-100';
            return baseImageUrl + imageUrl + '.svg';
            break;
          }
        }
        break;
      default: {
        imageUrl = 'badge-star-ribbon-100';
        return baseImageUrl + imageUrl + '.svg';
        break;
      }
    }
  }
}

export enum AgentBadgeRibbonEnum {
  AgentBadgeCertification = 1,
  AgentBadgeAward = 2,
  AgentBadgeLeadership = 3,
  AgentBadgeStateLeadership = 4,
  AgentRibbonNationalPresident = 5,
  AgentRibbonStateLeadership = 6
}
